import { useQuery } from "@tanstack/react-query";
import { Role, RoleService } from "../../../../../services/config/permission-config/role";
import { RolePermissions } from "../../../../../services/config/permission-config/employeeRole";
import { useCallback, useMemo } from "react";

export const useRole = () => {
  const { data = [], ...restResponse } = useQuery<Role[]>({
    queryKey: ["config-role"],
    queryFn: () => RoleService.getList(),
  });

  const listRoles = useMemo(
    () =>
      data
        ? data.map((role: Role) => ({
            key: role.id.toString(),
            label: role.roleName,
            description: role.description,
            note: role.note,
          }))
        : [],
    [data]
  );

  const listRolePermission = useCallback(
    (roleId: number) => {
      if (!data) return [];
      const currentData = data.find((e: Role) => e.id === roleId);
      if (!currentData) return [];
      const rolePermissions = currentData.rolePermissions ? [...currentData.rolePermissions] : [];
      return rolePermissions.map((rolePermission: RolePermissions) => ({
        roleId: rolePermission.roleId,
        permissionId: rolePermission.permissionId.toString(),
        create: rolePermission.c,
        view: rolePermission.r,
        edit: rolePermission.u,
        delete: rolePermission.d,
      }));
    },
    [data]
  );

  return {
    ...restResponse,
    listRoles,
    listRolePermission,
  };
};
